import "core-js/stable";
import "regenerator-runtime/runtime";
import App from './app';

declare global {
  interface Window { 
    theme: any,
    BISPopover: any,
    fbq: any,
    Shopify: any
  }
}

const app = new App();
app.init();
